import React, { useState, useRef } from 'react';
import { loginUrl2 } from '../../../utils/staticPageUrls';
import { Layout, Collapse, Button, Row, Col } from 'antd';
import { ReactComponent as Minus } from '../../../assets/icons/minus.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
import bot_img from '../../../assets/icons/Final_Chatobot_RGB.SVG';
import SubmitLanding from '../../../assets/icons/SubmitLanding.svg';
import bannerblue from '../../../assets/icons/bannerblue.png';
import { TableCell } from '@mui/material';
import HeaderLanding from './staticsHeader';
import Footer from '../../../components/footer/index.js'; //footer apo to app mesa
import Οδηγός_Εφαρμογής from '../../../assets/documents/ΦΕΚ ΔΕΥΑ.pdf';
import FAQ_ΔΕΥΑ from '../../../assets/documents/ΔΕΥΑ_Συχνές Ερωτήσεις v3.pdf';
// import Οδηγός from '../../../assets/documents/ΠΡΟΓΡΑΜΜΑ_ΔΕΥΑ_04_11_24.docx';
// import Footer from './staticFooter';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

const { Content } = Layout;
const { Panel } = Collapse;
// const { Option } = Select;

const StaticPage1 = () => {
  const documents = [
    {
      category: 'Οδηγός Προγράμματος',
      documents: [
        {
          label: 'Οδηγός Προγράμματος',
          date: '19/12/2024',
          link: Οδηγός_Εφαρμογής,
        },
      ],
    },
    {
      category: 'Διάφορα',
      documents: [
        {
          label: 'Διάφορα',
          // date: '25/09/2024',
          link: null,
        },
      ],
    },
  ];

  const faqDocuments = [
    {
      documents: [
        {
          label:
            'Συχνές Ερωτήσεις για «Προώθηση της ενεργειακής απόδοσης στις Δημοτικές Επιχειρήσεις Ύδρευσης και Αποχέτευσης (ΔΕΥΑ)»',
          // date: '25/09/2024',
          link: FAQ_ΔΕΥΑ,
        },
      ],
    },
  ];

  const comDocuments = [
    {
      documents: [
        {
          label: 'Banners Αλλάζω Συσκευή',
          date: '07/11/2024',
          link: null,
        },
      ],
    },
  ];

  const scrollToSection = elementRef => {
    window.scrollTo({
      top: elementRef.current.offsetTop,
      behavior: 'smooth',
    });
  };

  const NewsItem = ({ item }) => {
    const [showFullText, setShowFullText] = useState(false);

    return (
      <div className="flex-column">
        {/* <Col xs={24} sm={11} md={11} lg={7} xl={7}> */}
        {/* <img src={null} alt="recyclehouse" width="100%" /> */}
        <div className="news-title font-size-20 mt-2">{item.title}</div>
        <div className="news-content-container mt-2">
          <div className="news-date-container">
            <div className="news-date font-size-16">{item.date}</div>
            {item.text && (
              <div
                className="see-more font-size-16"
                onClick={() => setShowFullText(!showFullText)}
              >
                {showFullText ? 'Απόκρυψη' : 'Δείτε Περισσότερα'}
              </div>
            )}
          </div>
          {showFullText && (
            <div className="news-text mt-2 font-size-16">{item.text}</div>
          )}
        </div>
        <div className="news-text mt-2 font-size-16">{item.subtext}</div>
      </div>
    );
  };

  const news = [
    // {
    //   title:
    //     'Εδώ όταν πραγματοποιείται κάποια αλλαγή στο πρόγραμμα θα αναρτάται κείμενο (τίτλος) με ημερομηνία & πατώντας Δείτε περισσότερα θα παρουσιάζονται συνοπτικά οι αλλαγές',
    //   date: '26/09/24',
    //   text: (
    //     <div>
    //       <p>Sample Text Here...</p>
    //     </div>
    //   ),
    // },
    {
      title:
        'Παράταση υποβολής αιτήσεων σε τέσσερα προγράμματα ενεργειακής αναβάθμισης - Υπουργείο Περιβάλλοντος και Ενέργειας',
      date: '26/02/25',
      text: (
        <div>
          <p><a href="https://ypen.gov.gr/paratasi-ypovolis-aitiseon-se-tessera-programmata-energeiakis-anavathmisis/" target="_blank" rel="noopener noreferrer">Παράταση υποβολής αιτήσεων σε τέσσερα προγράμματα ενεργειακής αναβάθμισης - Υπουργείο Περιβάλλοντος και Ενέργειας</a></p>
        </div>
      ),
    },
    {
      title:
        'Παράταση υποβολής αιτήσεων στο πρόγραμμα «Προώθηση της ενεργειακής απόδοσης στις Δημοτικές Επιχειρήσεις Ύδρευσης και Αποχέτευσης» - Υπουργείο Περιβάλλοντος και Ενέργειας',
      date: '29/04/25',
      text: (
        <div>
          <p><a href="https://ypen.gov.gr/paratasi-ypovolis-aitiseon-sto-programma-proothisi-tis-energeiakis-apodosis-stis-dimotikes-epicheiriseis-ydrefsis-kai-apochetefsis/"  target="_blank" rel="noopener noreferrer">Παράταση υποβολής αιτήσεων στο πρόγραμμα «Προώθηση της ενεργειακής απόδοσης στις Δημοτικές Επιχειρήσεις Ύδρευσης και Αποχέτευσης» - Υπουργείο Περιβάλλοντος και Ενέργειας</a></p>
        </div>
      ),
    },
    {
      title:
        'Παράταση υποβολής αιτήσεων έως 30/6/2025 στο πρόγραμμα «Προώθηση της ενεργειακής απόδοσης στις Δημοτικές Επιχειρήσεις Ύδρευσης και Αποχέτευσης» - Υπουργείο Περιβάλλοντος και Ενέργειας.',
      date: '30/05/25',
      text: (
        <div>
          <p><a href="https://ypen.gov.gr/paratasi-ypovolis-aitiseon-sto-programma-proothisi-tis-energeiakis-apodosis-stis-dimotikes-epicheiriseis-ydrefsis-kai-apochetefsis-2/"  target="_blank" rel="noopener noreferrer">Παράταση υποβολής αιτήσεων στο πρόγραμμα «Προώθηση της ενεργειακής απόδοσης στις Δημοτικές Επιχειρήσεις Ύδρευσης και Αποχέτευσης» - Υπουργείο Περιβάλλοντος και Ενέργειας</a></p>
        </div>
      ),
    },
    {
      title:
        'Παράταση καταληκτικής ημερομηνίας ολοκλήρωσης του φυσικού και οικονομικού αντικειμένου των επιδοτούμενων δράσεων.',
      date: '19/09/25',
      text: (
        <div>
          <p><a href="https://ypen.gov.gr/to-ypourgeio-perivallontos-kai-energeias-anakoinonei-parataseis-se-energeiaka-programmata-entagmena-sto-tameio-anakampsis-kai-anthektikotitas/"  target="_blank" rel="noopener noreferrer">Το Υπουργείο Περιβάλλοντος και Ενέργειας ανακοινώνει παρατάσεις σε ενεργειακά προγράμματα, ενταγμένα στο Ταμείο Ανάκαμψης και Ανθεκτικότητας</a></p>
        </div>
      ),
    },
    // {
    //   title:
    //     (<a href="https://ypen.gov.gr/paratasi-ypovolis-aitiseon-se-tessera-programmata-energeiakis-anavathmisis/" target="_blank" rel="noopener noreferrer">Παράταση υποβολής αιτήσεων σε τέσσερα προγράμματα ενεργειακής αναβάθμισης - Υπουργείο Περιβάλλοντος και Ενέργειας</a>),
    //   date: '26/02/25',
    // },
    // {
    //   title:
    //     (<a href="https://ypen.gov.gr/paratasi-ypovolis-aitiseon-sto-programma-proothisi-tis-energeiakis-apodosis-stis-dimotikes-epicheiriseis-ydrefsis-kai-apochetefsis/" target="_blank" rel="noopener noreferrer">Παράταση υποβολής αιτήσεων στο πρόγραμμα «Προώθηση της ενεργειακής απόδοσης στις Δημοτικές Επιχειρήσεις Ύδρευσης και Αποχέτευσης» - Υπουργείο Περιβάλλοντος και Ενέργειας</a>),
    //   date: '29/04/25',
    // },
  ];

  const [generalInfo, setGeneralInfo] = useState(true);
  const [docsTab, setDocsTab] = useState(false);
  const [faqTab, setFaqTab] = useState(false);
  const [comTab, setComTab] = useState(false);
  const [activeKey, setActiveKey] = useState();
  const [showBot, setShowBot] = useState(false);
  const [minimizeBot, setMinimizeBot] = useState(false);

  const handleMinimize = () => {
    setShowBot(false);
    setMinimizeBot(true);
  };

  const handleOpen = () => {
    setShowBot(true);
    setMinimizeBot(false);
  };

  return (
    <Layout id="landing-page">
      <HeaderLanding
        setShowBot={setShowBot}
        showBot={showBot}
        className="header-landing"
      />
      <Content className="main-content">
        <div className="columns-container">
          {/* <Row gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }} className="mt-5 mb-3">
            <Col className="mb-5" xs={24} sm={24} md={24} lg={24} xl={24}> */}
          <Row gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className="title-blue font-size-32 mt-5">
                Προώθηση της ενεργειακής απόδοσης στις Δημοτικές Επιχειρήσεις 
                Ύδρευσης και Αποχέτευσης
              </div>
              <div className="mt-3 font-size-16">
                <p style={{ textAlign: 'justify' }}>
                  Το πρόγραμμα «Προώθηση της ενεργειακής απόδοσης στις Δημοτικές
                  Επιχειρήσεις Ύδρευσης και Αποχέτευσης (ΔΕΥΑ)» στοχεύει στη
                  μείωση της κατανάλωσης ενέργειας και των εκπομπών CO₂ μέσω
                  επεμβάσεων ενεργειακής αναβάθμισης και βελτίωσης της
                  λειτουργικής αποδοτικότητας στα αντλιοστάσια των ΔΕΥΑ.
                </p>
                <p>
                  Οι επιλέξιμες δράσεις χωρίζονται σε δύο βασικές κατηγορίες:
                </p>
                <ol>
                  <li>
                    <strong>Άμεσες Επεμβάσεις Ενεργειακής Αναβάθμισης:</strong>
                    <ul>
                      <li style={{ textAlign: 'justify' }}>
                        Εξοπλισμός για τη βελτίωση της ενεργειακής απόδοσης
                        αντλιοστασίων ύδρευσης και αποχέτευσης (π.χ.,
                        αντικατάσταση κινητήρων, εγκατάσταση inverter,
                        τηλεχειρισμός αντλιοστασίων).
                      </li>
                      <li style={{ textAlign: 'justify' }}>
                        Υποστήριξη μέσω σχετικών μελετών και υπηρεσιών, όπως
                        ενεργειακοί έλεγχοι και προετοιμασία φακέλων υποβολής
                        αίτησης.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong>
                      Στρατηγικές Μελέτες Μακροπρόθεσμης Εξοικονόμησης
                      Ενέργειας:
                    </strong>
                    <ul>
                      <li style={{ textAlign: 'justify' }}>
                        Εντοπισμός, αξιολόγηση και αποτύπωση δυνατοτήτων
                        ενεργειακής εξοικονόμησης σε επίπεδο οργανισμού.
                      </li>
                      <li style={{ textAlign: 'justify' }}>
                        Παροχή στρατηγικού πλαισίου για μελλοντικές δράσεις,
                        χωρίς ωστόσο να καλύπτονται οι προτεινόμενες επενδύσεις
                        από το πρόγραμμα.
                      </li>
                    </ul>
                  </li>
                </ol>
                <p>
                  Η χρηματοδότηση πραγματοποιείται μέσω δεσμευμένων λογαριασμών
                  (escrow accounts).
                </p>
                <p>
                Η καταληκτική ημερομηνία ολοκλήρωσης του φυσικού και οικονομικού αντικειμένου των επιδοτούμενων δράσεων, παρατείνεται έως την <strong>30η Ιουνίου 2026</strong>.
                </p>
                <p style={{ textAlign: 'justify' }}>
                  <strong>
                    Το πρόγραμμα αποτελεί σημαντική ευκαιρία για τις ΔΕΥΑ να
                    αναβαθμίσουν τις ενεργειακές τους υποδομές και να μειώσουν
                    το κόστος λειτουργίας, ενισχύοντας την περιβαλλοντική
                    βιωσιμότητα.
                  </strong>
                </p>
                <p style={{ textAlign: 'justify' }}>
                  <strong>
                  Το Πρόγραμμα υλοποιείται στο πλαίσιο του Εθνικού Σχεδίου Ανάκαμψης 
                  και Ανθεκτικότητας Ελλάδας 2.0, με τη χρηματοδότηση της Ευρωπαϊκής Ένωσης - NextGenerationEU.
                  </strong>
                </p>

                {/* Section 1 */}
              </div>
            </Col>
            <Col span={2}></Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              {/* <img
                className="panels-round"
                src={panels}
                alt="panels"
                style={{width:"100%", marginTop:"0", marginBottom:"-1.25rem"}}
              /> */}
            </Col>
          </Row>
        </div>
        {/* <div className="deadline-extension-banner mt-5">
        <p className="deadline-extension-text">
          <strong>Το τηλεφωνικό κέντρο του Helpdesk του Προγράμματος 
            δεν θα λειτουργεί από 11 έως και 15 Αυγούστου</strong>
        </p>
      </div> */}
      </Content>
      {/* <Row gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }} className="mt-5 mb-5"> */}
      <div
        style={{
          backgroundColor: '#003375',
          height: '400px',
          flexShrink: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div className="title-white font-size-32 text-center mb-5">
            Θέλω να αναβαθμιστώ
          </div>

          {process.env.REACT_APP_LOGIN_TO_PLATFORM === 'true' && (
            <Button id="entry-button" type="link" className="applicationButton">
              <a
                href={loginUrl2}
                target="_blank"
                rel="noreferrer"
                style={{
                  textDecoration: 'none',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  textAlign: 'center',
                }}
              >
                Είσοδος στην Ψηφιακή Πλατφόρμα Αιτήσεων
              </a>
            </Button>
          )}
        </div>
      </div>
      {/* </Row> */}

      {/* <div className="title-blue font-size-40">
        ΑΛΛΑΖΩ ΣΥΣΚΕΥΗ ΓΙΑ ΤΙΣ ΕΠΙΧΕΙΡΗΣΕΙΣ
      </div> */}
      <div className="main-content">
        <div className="title-blue font-size-32 text-center mt-11 mb-5">
          Νέα και Ανακοινώσεις
        </div>
        <Row
          justify="left"
          gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
          className="mt-5 mb-5"
        >
          {news.map((item, index) => {
            return (
              <>
                <NewsItem key={index} item={item} />
              </>
            );
          })}
        </Row>
        <div className="collapse-header-wrapper">
          <div className="collapse-header">
            <Button
              id="program-documents-button"
              style={{ backgroundColor: '#1782D5', color: 'white' }}
              onClick={() => {
                setDocsTab(!docsTab);
                setComTab(false);
                setFaqTab(false);
              }}
            >
              ΕΓΓΡΑΦΑ ΠΡΟΓΡΑΜΜΑΤΟΣ
            </Button>
            <Button
              id="faq-button"
              style={{ backgroundColor: '#1782D5', color: 'white' }}
              onClick={() => {
                setFaqTab(!faqTab);
                setComTab(false);
                setDocsTab(false);
              }}
            >
              ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ
            </Button>
          </div>
        </div>

        {/* Expandable Content */}
        <div className="expandable-container">
          {docsTab && (
            <div id="documents-section" className="documents-content">
              <h1 className="documents-header">Έγγραφα Προγράμματος</h1>
              <div className="documents-items">
                {documents.map(item => (
                  <div className="docs" key={item.category}>
                    <h2 className="documents-category">{item.category}</h2>
                    <div className="documents-info">
                      {item.documents.map(doc => (
                        <div key={doc.label}>
                          <a target="_blank" rel="noreferrer" href={doc.link}>
                            {doc.label}
                          </a>
                          <p>{doc.date}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {faqTab && (
            <div id="faq-section" className="documents-content">
              <h1 className="documents-header">Συχνές Ερωτήσεις</h1>
              <div className="documents-items">
                {faqDocuments.map(item => (
                  <div className="docs" key={item.documents[0].label}>
                    <div className="documents-info">
                      {item.documents.map(doc => (
                        <div key={doc.label}>
                          <a target="_blank" rel="noreferrer" href={doc.link}>
                            {doc.label}
                          </a>
                          <p>{doc.date}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <Content className="main-content">
        <div style={{ marginTop: '-7.5rem', marginBottom: '-2.5rem' }}>
          <Collapse
            id="contact-info-collapse"
            key="1"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '1' ? setActiveKey('') : setActiveKey('1')
            }
            activeKey={activeKey}
          >
            <Panel
              header={<text style={{ color: 'white' }}>Επικοινωνία</text>}
              key="1"
            >
              <div>
                <b>Επικοινωνία</b>
                <br></br>
                <br></br>
                <p>
                  Για οποιαδήποτε πληροφορία σχετική με το Πρόγραμμα ή
                  οποιοδήποτε ζήτημα που προκύπτει κατά τη διαδικασία υποβολής
                  των αιτήσεων συμμετοχής, μπορείτε να επικοινωνήσετε μαζί μας
                  αποστέλλοντας ένα ηλεκτρονικό μήνυμα στη διεύθυνση{' '}
                  <a>deya@prv.ypeka.gr</a>
                </p>
                <p>
                  Για ζητήματα που προκύπτουν κατά τη διαδικασία υποβολής των
                  αιτήσεων συμμετοχής παρακαλούμε στο μήνυμά σας να
                  συμπεριλαμβάνετε τον Αριθμό Αίτησης ή το ΑΦΜ.
                </p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            id="beneficiaries-collapse"
            key="2"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '2' ? setActiveKey('') : setActiveKey('2')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text style={{ color: 'white' }}>
                  Δικαιούχοι του Προγράμματος
                </text>
              }
              key="2"
            >
              <div>
                <b>Δικαιούχοι του Προγράμματος</b>
                <br></br>
                <br></br>
                <p>
                  <ul style={{ listStyleType: 'circle' }}>
                    <li>
                      Δημοτικές Επιχειρήσεις Ύδρευσης και Αποχέτευσης (ΔΕΥΑ).
                    </li>
                    <li>Συμπράξεις μεταξύ ΔΕΥΑ.</li>
                    <li>
                      Το πρόγραμμα καλύπτει το σύνολο της ελληνικής επικράτειας.
                    </li>
                  </ul>
                </p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            id="funding-collapse"
            key="3"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '3' ? setActiveKey('') : setActiveKey('3')
            }
            activeKey={activeKey}
          >
            <Panel
              header={<text style={{ color: 'white' }}>Ύψος Ενισχύσεων</text>}
              key="3"
            >
              <div>
                <b>Ύψος Ενισχύσεων</b>
                <br></br>
                <br></br>
                <p>
                  <ul style={{ listStyleType: 'circle' }}>
                    <li>
                      Ο συνολικός προϋπολογισμός του Προγράμματος ανέρχεται στα
                      40.000.000,00 (€) (χωρίς Φ.Π.Α.)
                    </li>
                    <li>
                      Ο Φ.Π.Α. δεν είναι επιλέξιμος στο πλαίσιο του
                      Προγράμματος, καθώς είναι ανακτήσιμος από τους Δικαιούχους
                      Φορείς.
                    </li>
                    <li>
                      Ως μέγιστος συνολικός και επιλέξιμος Προϋπολογισμός των
                      υποβαλλόμενων Αιτήσεων Ένταξης ορίζεται το ποσό των
                      4.032.258,06 (€), χωρίς Φ.Π.Α. (5.000.000,00 ευρώ με
                      Φ.Π.Α.).
                    </li>
                    <li>
                      Ως ελάχιστος συνολικός και επιλέξιμος Προϋπολογισμός των
                      υποβαλλόμενων Αιτήσεων Ένταξης ορίζεται το ποσό των
                      80.645,16 (€) χωρίς Φ.Π.Α. (€100.000,00 (€)
                      συμπεριλαμβανομένου Φ.Π.Α.).
                    </li>
                    <li>
                      Το ποσοστό επιδότησης ορίζεται στο 80% της καθαρής (χωρίς
                      Φ.Π.Α.) αξίας των επιλέξιμων δαπανών. Κατ’ επέκταση,
                      ανώτατο συνολικό ποσό επιδότησης από το Πρόγραμμα ανά
                      Δικαιούχο Φορέα είναι το ποσό των 3.225.806,45 (€).
                    </li>
                    <li>
                      Ως ανώτατος επιλέξιμος προϋπολογισμός για τις συνοδές
                      μελέτες που αναφέρονται στην Κατηγορία Ι του Άρθρου 1 της
                      Πρόσκλησης, ορίζεται το 3% του συνολικού επιλέξιμου
                      προϋπολογισμού της Αίτησης, ήτοι κατά μέγιστο 120.967,74
                      (€) χωρίς Φ.Π.Α. (150.000,00 (€) με Φ.Π.Α.). Οι μελέτες
                      αυτές επιδοτούνται με 80% επί της καθαρής (χωρίς Φ.Π.Α.)
                      αξίας τους, άρα το ανώτατο ποσό επιδότησης που δύναται να
                      λάβει ο Δικαιούχος Φορέας για αυτές ανέρχεται στα
                      96.774,19 (€) .
                    </li>
                    <li>
                      Ως ανώτατος επιλέξιμος προϋπολογισμός για τις
                      συμβουλευτικές υπηρεσίες/ μελέτες που αναφέρονται στην
                      Κατηγορία ΙΙ του Άρθρου 1 της Πρόσκλησης, ορίζεται το 2%
                      του συνολικού επιλέξιμου προϋπολογισμού της Αίτησης, ήτοι
                      κατά μέγιστο 80.645,16 (€) χωρίς Φ.Π.Α. (100.000 (€) με
                      Φ.Π.Α.). Οι μελέτες αυτές επιδοτούνται με 80% επί της
                      καθαρής (χωρίς Φ.Π.Α.) αξίας τους, άρα το ανώτατο ποσό
                      επιδότησης που δύναται να λάβει ο Δικαιούχος Φορέας από το
                      Πρόγραμμα για αυτές ανέρχεται στα 64.516,13 (€).
                    </li>
                  </ul>
                </p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            id="eligible-expenses-collapse"
            key="4"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '4' ? setActiveKey('') : setActiveKey('4')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text style={{ color: 'white' }}>Επιλέξιμες Δαπάνες</text>
              }
              key="4"
            >
              <div>
                <b>Επιλέξιμες Δαπάνες</b>
                <br></br>
                <br></br>
                <p>
                  <ol>
                    <li>
                      Άμεσες Επεμβάσεις Ενεργειακής Αναβάθμισης:
                      <ul>
                        <li>
                          Εξοπλισμός για τη βελτίωση της ενεργειακής απόδοσης
                          αντλιοστασίων ύδρευσης και αποχέτευσης (π.χ.,
                          αντικατάσταση κινητήρων, εγκατάσταση inverter,
                          τηλεχειρισμός αντλιοστασίων).
                        </li>
                        <li>
                          Υποστήριξη μέσω σχετικών μελετών και υπηρεσιών, όπως
                          ενεργειακοί έλεγχοι και προετοιμασία φακέλων υποβολής
                          αίτησης.
                        </li>
                      </ul>
                    </li>
                    <li>
                      Στρατηγικές Μελέτες Μακροπρόθεσμης Εξοικονόμησης
                      Ενέργειας:
                      <ul>
                        <li>
                          Εντοπισμός, αξιολόγηση και αποτύπωση δυνατοτήτων
                          ενεργειακής εξοικονόμησης σε επίπεδο οργανισμού.
                        </li>
                        <li>
                          Παροχή στρατηγικού πλαισίου για μελλοντικές δράσεις,
                          χωρίς ωστόσο να καλύπτονται οι προτεινόμενες
                          επενδύσεις από το πρόγραμμα.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </p>
              </div>
            </Panel>
          </Collapse>

          <Collapse
            id="program-process-collapse"
            key="5"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '5' ? setActiveKey('') : setActiveKey('5')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text style={{ color: 'white' }}>
                  Διαδικασία του Προγράμματος
                </text>
              }
              key="5"
            >
              <div>
                <b>Διαδικασία του Προγράμματος</b>
                <br></br>
                <br></br>
                <p>
                  <ul style={{ listStyleType: 'circle' }}>
                    <li>Υποβολή αιτήσεων μέσω πληροφοριακού συστήματος.</li>
                    <li>
                      Αξιολόγηση αιτήσεων από επιτροπή του Φορέα Υλοποίησης.
                    </li>
                    <li>
                      Πιστοποίηση επίτευξης των στόχων του Προγράμματος μέσω
                      Ενεργειακών Ελέγχων πριν και μετά τις επεμβάσεις.
                    </li>
                    <li>Εκταμίευση των ενισχύσεων.</li>
                  </ul>
                  <p>
                    Οι δικαιούχοι υποχρεούνται να διασφαλίσουν τη λειτουργία και
                    συντήρηση των έργων για τουλάχιστον 5 έτη μετά την
                    ολοκλήρωσή τους και τα έργα πρέπει να συμμορφώνονται με την
                    αρχή «μη πρόκλησης σημαντικής βλάβης» (DNSH).
                  </p>
                </p>
              </div>
            </Panel>
          </Collapse>
          <Collapse
            id="eligibility-criteria-collapse"
            key="6"
            className="main-content__collapse"
            expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
            expandIconPosition={'right'}
            onChange={e =>
              activeKey === '6' ? setActiveKey('') : setActiveKey('6')
            }
            activeKey={activeKey}
          >
            <Panel
              header={
                <text style={{ color: 'white' }}>
                  Προϋποθέσεις και Κριτήρια Επιλεξιμότητας
                </text>
              }
              key="6"
            >
              <div>
                <b>Προϋποθέσεις και Κριτήρια Επιλεξιμότητας</b>
                <br></br>
                <br></br>
                <p>
                  <ul style={{ listStyleType: 'circle' }}>
                    <li>
                      Κάθε πρόταση πρέπει να αποδεικνύει μείωση κατανάλωσης
                      πρωτογενούς ενέργειας τουλάχιστον κατά 20% στα ενταγμένα
                      αντλιοστάσια.
                    </li>
                    <li>
                      Η επιλογή των αντλιοστασίων προς ένταξη θα πρέπει να
                      βασίζεται στη δυναμική εξοικονόμησης ενέργειας, τις
                      εκπομπές CO₂ και την ετήσια κατανάλωση ενέργειας των
                      υφιστάμενων υποδομών.
                    </li>
                  </ul>
                </p>
              </div>
            </Panel>
          </Collapse>
        </div>
      </Content>
      <Content>
        <Footer />
      </Content>
    </Layout>
  );
};

export default StaticPage1;
